import { render, staticRenderFns } from "./Teams.vue?vue&type=template&id=397b98e4"
import script from "./Teams.js?vue&type=script&lang=js&external"
export * from "./Teams.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports